<template>
    <client-page>
        <sub-visual sh="시설 및 참여" tabActive="시설소개" bg="/images/sub/visual/sv2.jpg"> </sub-visual>

        <section class="section">
            <v-container>
                <dept3-tab page="시설소개" tabActive="1" />

                <div class="tit-wrap">
                    <h3 class="tit font-weight-bold">VR 스포츠 룸</h3>
                </div>

                <div class="mb-50 mb-lg-80">
                    <center-top sc1="“버커니어즈 VR 스포츠룸, 아이들의 또 다른 출발선.” <br>첨단 VR로 어디서도 못한 스포츠를 경험합니다." sc2="안전한 미래 체험 <br>“기후·환경 제약 없이, 모두가 함께 즐기는 스포츠.” <br>안전하고 친환경적인 공간에서 배우고 성장합니다.">
                        <slide-primary slideNum="1" className="pagination-top">
                            <div v-for="(image, index) in images" :key="index" class="swiper-slide">
                                <img :src="image" alt="" class="d-block w-100" />
                            </div>
                        </slide-primary>
                    </center-top>
                </div>

                <div class="mb-50 mb-lg-80">
                    <v-row>
                        <v-col v-for="(item, index) in items" :key="index" cols="12" sm="6" lg="3" class="mb-10 mb-lg-0">
                            <num-item :num="`0${index + 1}`">
                                <icon-primary className="mb-10 mb-lg-20" :icon="item.icon" maxWidth="40" />
                                <p class="page-text page-text--sm" v-html="item.text" />
                            </num-item>
                        </v-col>
                    </v-row>
                </div>

                <div class="mb-50 mb-lg-74 w-100">
                    <v-img src="/images/sub/center/vr/map.jpg" class="w-100"></v-img>
                </div>

                <h5 class="tit--sm font-weight-bold mb-10 mb-lg-26">찾아 오시는 길</h5>

                <div class="pa-20 pa-ma-30 pa-lg-50 border border-color-light border-2 border-lg-4">
                    <div class="d-lg-flex align-center mb-12 mb-lg-20">
                        <p class="w-60px w-lg-100px py-4 page-text text-center bg-secon color-white mb-2 mb-lg-0 mr-12 mr-lg-40 font-weight-bold">주소</p>
                        <p class="color-grey page-text">서울 강서구 강서로54길 93 1층</p>
                    </div>
                    <div class="d-lg-flex align-center">
                        <p class="w-60px w-lg-100px py-4 page-text text-center bg-secon color-white mb-2 mb-lg-0 mr-12 mr-lg-40 font-weight-bold">대중교통</p>
                        <div class="d-lg-flex align-center page-text">
                            <div class="d-flex">
                                <p class="font-weight-bold w-40px w-lg-auto mr-4 mr-lg-14">지하철</p>
                                <div class="d-flex align-center">
                                    <!-- <span class="dot mr-2 mr-lg-4" style="background-color: #4b80ea"></span> -->
                                    <span class="dot mr-4 mr-lg-10" style="background-color: #996cac" />
                                    <p class="color-grey">5호선 발산역 기준 3,4번 출구 도보 630m (10분) 이동</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import Dept3Tab from "@/components/client/ko/sub/dept3-tab.vue";
import NumItem from "@/components/client/ko/sub/sub-num-item.vue";
import SlidePrimary from "@/components/client/ko/sub/sub-slide-primary.vue";
import CenterTop from "@/components/client/ko/sub/sub-center-top.vue";
import IconPrimary from "@/components/client/ko/sub/sub-icon-primary.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        Dept3Tab,
        NumItem,
        SlidePrimary,
        CenterTop,
        IconPrimary,
    },
    data() {
        return {
            images: [
                "/images/sub/center/vr/s1-img1.jpg",
                "/images/sub/center/vr/s1-img2.jpg",
                "/images/sub/center/vr/s1-img3.jpg",
                "/images/sub/center/vr/s1-img4.jpg",
                //
            ],
            items: [
                {
                    icon: "/images/sub/center/vr/s1-icon1.svg",
                    text: "몰입형 VR 기술을 활용한 <br class='d-none d-lg-block'>유아 맞춤형 스포츠 프로그램으로, <br class='d-none d-lg-block'>축구 중심의 다양한 신체 활동을 안전한 실내에서 즐겁게 경험하며 체력·기술·협동심을 자연스럽게 키움",
                },
                {
                    icon: "/images/sub/center/vr/s1-icon2.svg",
                    text: "준비운동·기초체육→ <br class='d-none d-lg-block'>VR축구 훈련 <br class='d-none d-lg-block'>(드리블·패스·슈팅·골키퍼) → <br class='d-none d-lg-block'>미니게임·협동놀이→ <br class='d-none d-lg-block'>정리운동·피드백 순으로 운영",
                },
                {
                    icon: "/images/sub/center/vr/s1-icon3.svg",
                    text: "기관 단체 참여 시 <br class='d-none d-lg-block'>아이들은 팀워크 · 협력을 배우며, <br class='d-none d-lg-block'>맞춤형 VR 축구 체험으로 기관 <br class='d-none d-lg-block'>차원의 높은 교육 효과와 브랜드 <br class='d-none d-lg-block'>가치까지 높일 수 있음",
                },
                {
                    icon: "/images/sub/center/vr/s1-icon4.svg",
                    text: "단순 체험을 넘어 <br class='d-none d-lg-block'>아이들이 꾸준히 성장해 <br class='d-none d-lg-block'>유아축구대회 참가로 <br class='d-none d-lg-block'>성취감과 자신감을 <br class='d-none d-lg-block'>쌓는 기회를 제공.",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
</style>
